module.exports = __webpack_public_path__ + "media/winner_double_line_5.92c0a800.mp3";